"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraButtonsContainer = void 0;
const react_1 = __importDefault(require("react"));
require("../styles/eura-buttons-container.css");
const EuraButtonsContainer = (props) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'eura-buttons-container' }, props.children),
        react_1.default.createElement("div", { className: 'eura-buttons-container-bottom-line ' })));
};
exports.EuraButtonsContainer = EuraButtonsContainer;
